import React from 'react';
import { Modal, Select, Input, Button, Space, message } from 'antd';
import { EditOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const reasonOptions = [
  { value: 'admin_adjust', label: 'Admin Adjust' },
  { value: 'cancelled_by_student', label: 'Cancelled by student (CL by S)' },
  { value: 'cancelled_by_teacher', label: 'Cancelled by teacher (CL by T)' },
  { value: 'class_on_hold_by_student', label: 'Class on hold by student' },
  { value: 'class_on_hold_by_school', label: 'Class on hold by school' },
  { value: 'cancelled_same_day_teacher', label: 'Cancelled same day CSD (Teacher)' },
  { value: 'cancelled_same_day_student', label: 'Cancelled same day CSD (Student)' },
  { value: 'teacher_late', label: 'Teacher Late' },
  { value: 'kease_cut', label: 'KEAES Cut' },
  { value: 'make_up', label: 'Make Up' },
  { value: 'others', label: 'Others' },
];

const CustomModal = ({ isOpen, onClose, onSubmit, reason, setReason, note, setNote }) => {
  const handleSubmit = () => {
    if (!reason) {
      message.warning('Please select a reason');
      return;
    }
    onSubmit(reason, note);
    setReason('');
    setNote('');
    onClose();
  };

  return (
    <Modal
      title={
        <Space>
          <EditOutlined />
          <span>Reason for Change</span>
        </Space>
      }
      open={isOpen}
      onCancel={onClose}
      footer={
        <Space>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Space>
      }
      destroyOnClose
      width={480}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, paddingTop: 8 }}>
        <div>
          <div style={{ marginBottom: 6, fontWeight: 500 }}>Reason</div>
          <Select
            value={reason || undefined}
            onChange={setReason}
            placeholder="Select a reason"
            options={reasonOptions}
            style={{ width: '100%' }}
            size="large"
          />
        </div>
        <div>
          <div style={{ marginBottom: 6, fontWeight: 500 }}>Note</div>
          <TextArea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Add a note (optional)"
            rows={3}
            size="large"
          />
        </div>
      </div>
    </Modal>
  );
};

export default CustomModal;
